export default "__VITE_PUBLIC_ASSET__d8eab6e9__"